import { render, staticRenderFns } from "./grievance.vue?vue&type=template&id=ec3885f6&scoped=true&"
import script from "./grievance.vue?vue&type=script&lang=js&"
export * from "./grievance.vue?vue&type=script&lang=js&"
import style0 from "./grievance.vue?vue&type=style&index=0&id=ec3885f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3885f6",
  null
  
)

export default component.exports